import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import Collapse from "@material-ui/core/Collapse";
import Slider from "@material-ui/core/Slider";
import withStyles from "@material-ui/core/styles/withStyles";
import CheckImg from "Assets/Images/aaa.png";
import CallOutNew from "Component/Headers/callOutNew";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import headersList from "Constants/headersList";
import { withSnackbar } from "notistack";
import React from "react";
import Helmet from "react-helmet";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance } from "../../../../../Actions/AxiosInstance";
import {
  CheckActionPermission,
  setHelperText,
} from "../../../../../Actions/commonAction";
import "../../index.css";

import Switch from "@material-ui/core/Switch";


const marks = () =>
  [
   0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ].map((x) => ({ value: x, label: JSON.stringify(x) }));

function valuetext(value) {
  return `${value}`;
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});
class ConfigureCycle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { readOnly: false, editable: false },
      CycleInfo: [],
      Dates: [
        { displayvalue: 1, displayname: "1" },
        { displayvalue: 2, displayname: "2" },
        { displayvalue: 3, displayname: "3" },
        { displayvalue: 4, displayname: "4" },
        { displayvalue: 5, displayname: "5" },
        { displayvalue: 6, displayname: "6" },
        { displayvalue: 7, displayname: "7" },
        { displayvalue: 8, displayname: "8" },
        { displayvalue: 9, displayname: "9" },
        { displayvalue: 10, displayname: "10" },
        { displayvalue: 11, displayname: "11" },
        { displayvalue: 12, displayname: "12" },
        { displayvalue: 13, displayname: "13" },
        { displayvalue: 14, displayname: "14" },
        { displayvalue: 15, displayname: "15" },
        { displayvalue: 16, displayname: "16" },
        { displayvalue: 17, displayname: "17" },
        { displayvalue: 18, displayname: "18" },
        { displayvalue: 19, displayname: "19" },
        { displayvalue: 20, displayname: "20" },
        { displayvalue: 21, displayname: "21" },
        { displayvalue: 22, displayname: "22" },
        { displayvalue: 23, displayname: "23" },
        { displayvalue: 24, displayname: "24" },
        { displayvalue: 25, displayname: "25" },
        { displayvalue: 26, displayname: "26" },
        { displayvalue: 27, displayname: "27" },
        { displayvalue: 28, displayname: "28" },
        { displayvalue: 29, displayname: "29" },
        { displayvalue: 30, displayname: "30" },
        { displayvalue: 31, displayname: "31" },
      ],
      attcyclestartday: { displayvalue: null, displayname: null },
      attcycleendday: { displayvalue: null, displayname: null },
      isallowcyclebypass:false,
      requestcycleid: this.props.match.params.requestcycleid,
      islockattendance: false,
      value: 0,
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentWillMount() {
   
     this.getAttendanceRequestCycle();
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);

    const [isTrue, permissions] = CheckActionPermission("requestCycle");
    if (isTrue) {
      this.setState({ permissions });
    } else {
    
      this.setState({ permissiondenied: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }


  getAttendanceRequestCycle() {
    instance
      .get("/attendance/getrequestcycle")
      .then((result) => {
        let CycleInfo = [];
        let requestcycleid = "";
        if (result.data.result.length > 0) {
          requestcycleid = result.data.result[0].requestcycleid;
        }
        CycleInfo = result.data.result;
        this.setState({ CycleInfo, requestcycleid });
        if (CycleInfo.length != 0) {
        
          const attcyclestartday = this.state.Dates.find(
            (x) => x.displayvalue == result.data.result[0].attcyclestartday,
          );
          const attcycleendday = this.state.Dates.find(
            (x) => x.displayvalue == result.data.result[0].attcycleendday,
          );

          const value = CycleInfo[0].regularizationcutoff;
          const isallowcyclebypass = CycleInfo[0].isallowcyclebypass;
          const islockattendance = result.data.result.length == 0 ? false : true;
          this.setState({
            attcyclestartday,
            attcycleendday,
            value,
            isallowcyclebypass,
            islockattendance  
          });
        }
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  onSave(){
    if (this.state.islockattendance) {
      this.UpdateAttendanceCycle();
    } else {
      this.InactiveCycle();
    }
  }

  UpdateAttendanceCycle() {
    const data = {
      requestcycleid: this.state.requestcycleid ? this.state.requestcycleid :null,
    regularizationcutoff:  this.state.value,
    attcyclestartday : this.state.attcyclestartday.displayvalue,
    attcycleendday : this.state.attcycleendday.displayvalue,
    isallowcyclebypass : this.state.isallowcyclebypass
    };
   

    instance
      .post("/attendance/insertupdaterequestcycle", data)
      .then((result) => {
        this.props.enqueueSnackbar("Lock attendance saved successfully", {
          variant: "success",
        });
        this.getAttendanceRequestCycle();
       
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  InactiveCycle() {
   

    instance
      .post("attendance/inactiverequestcycle", )
      .then((result) => {
        this.props.enqueueSnackbar("Saved successfully", {
          variant: "success",
        });
        this.getAttendanceRequestCycle();
       
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  
  

  
  UpdateSelectedDate(key, selectedItem) {
    if (key == "attcyclestartday") {
      this.setState({
        attcyclestartday: selectedItem,
      })
    }
    if (key == "attcycleendday") {
    
      this.setState({
        attcycleendday: selectedItem,
      })
    
    }
    
  }

  handleChange = (key, value) => {
    this.setState({ [key]: value });
  };

  handleChange1 = (event, value) => {
    this.setState({ value });
  };

  render() {
    const { value } = this.state;
    const { classes = {} } = this.props;

    return (
     
        <div className="content-outer-wrapper">
          <Helmet>
            <title>{headersList.Config.AttendanceRequestCycle.header}</title>

          </Helmet>
          <p className="large-text-dark margin-bottom-24">Attendance lock cycle</p>
          {this.state.permissiondenied ? (
            <div className="position-rel">
              <PermissionDeniedComp />
            </div>
          ) : (
            <Grid container >
              <Grid item sm={12} md={10}>
              
                <div className="margin-top-10">
                  <p className="depedent-select-list-head">
                    Do you wish to lock the attendance?
                  </p>
                  <div
                    className={
                      this.state.islockattendance == true
                        ? "depedent-select-list select-list-item"
                        : "depedent-select-list"
                    }
                    onClick={() => this.handleChange("islockattendance", true)}
                  >
                    <span>
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />
                    </span>
                    {this.state.islockattendance == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>
                  {this.state.islockattendance == true ? (
                    <div className="bottom-border"></div>
                  ) : (
                    ""
                  )}
                  <div className="inner-level-div iplist-attendence">
                    <Collapse
                      in={this.state.islockattendance}
                      timeout="auto"
                      unmountOnExit
                      className="overflow-initial first-level-padding"
                    >

                      <p className="normal-dark margin-right-16 margin-top-16">
                      Attendance lock start day
                      </p>
                      <div style={{ width:145, height: 40, marginBottom: 16 }}>
                        <Select
                          className="selectsearch width100 inlindClass"
                          tabIndex="0"
                          onChange={this.UpdateSelectedDate.bind(this, "attcyclestartday")}
                          options={this.state.Dates}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.attcyclestartday}
                          placeholder="Select day"
                        />
                      </div>
                      <p className="normal-dark margin-right-16 ">
                        Attendance lock end day
                      </p>


                      <div style={{ width: 145, height: 40, marginBottom: 16 }}>
                        <Select
                          className="selectsearch width100 inlindClass"
                          tabIndex="0"
                          onChange={this.UpdateSelectedDate.bind(this, "attcycleendday")}
                          options={this.state.Dates}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.attcycleendday}
                          placeholder="Select day"
                        />
                      </div>

                      <p className="normal-dark margin-right-16 ">
                         Regularization cut-off (Buffer days after cycle end date for employees to send request for attendance update, out duty/wfh & leaves)
                      </p>

                      <div className="control-pane" style={{position:"relative", zIndex:0}}>
                        <div className="control-section">
                          <div className="slider-content-wrapper">
                            <div tabIndex="6">
                              <div
                                className="margin-top-24"
                                id="slider_wrapper"
                              >

                                <Slider
                                  className="margin-top-20"
                                  defaultValue={20}
                                  getAriaValueText={valuetext}
                                  aria-labelledby="discrete-slider-custom"
                                  step={1}
                                  min={0}
                                  max={10}
                                  valueLabelDisplay="on"
                                  marks={marks()}
                                  value={value}
                                  size="small"
                                  onChange={this.handleChange1}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <p className="normal-dark t-bold margin-top-24">Cycle Bypass</p>

                      <div className="display-flex" style={{justifyContent:"space-between"}}>
                        <div className="floatleft margin-right-16 margin-top-4">
                          <div className="expense-limit-switch">
                            <p className="depedent-select-list-head">
                            Allow employees to bypass cycle's limitations (Enable this setting temporarily when you want to allow any employee to request for regularisation after the cut-off date)
                            </p>
                          </div>
                        </div>
                        <div className="floatleft margin-top-16">
                          <Switch
                            classes={{
                              switchBase: classes.colorSwitchBase,
                              checked: classes.colorChecked,
                              bar: classes.colorBar,
                            }}
                           
                            color="primary"
                            checked={
                              this.state.isallowcyclebypass ? true : false
                            }
                            onChange={() => {
                             
                                this.setState(
                                  {
                                    isallowcyclebypass:
                                      !this.state.isallowcyclebypass,
                                  },
                                  
                                );
                            }}
                          />
                        </div>
                      </div>
                     
                    </Collapse>

                  </div>

                  <div
                    className={
                      this.state.islockattendance == false
                        ? "depedent-select-list select-list-item"
                        : "depedent-select-list"
                    }
                    onClick={() => this.handleChange("islockattendance", false)}
                  >
                    <span>
                      <FormattedMessage id="LbNo" defaultMessage="No" />
                    </span>
                    {this.state.islockattendance == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected"></span>
                    )}
                  </div>

                  <CallOutNew
                classnames="bg-light-red margin-top-16"
                header="Attendance Request Cycle & Salary Cycle must be kept in-sync for your payroll to work correctly."
                emoji="⚠️"
                textcolor="#f86b07"
              />
                </div>

              

              </Grid>
              <Grid item sm={12} md={8}>
             
            
              </Grid>
              <Grid item sm={12} md={8}>
              <Button
                className="btn btn-primary-md-blue margin-top-24"
                onClick={this.onSave}
              >
                Save
              </Button>
              </Grid>
            </Grid>
          )}
        </div>
    
    );
  }
}

const mapStateToProps = (state) => ({

});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ConfigureCycle)));
